import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { isPlatformServer } from '@angular/common';

@Component({
    selector: 'app-silent-refresh',
    templateUrl: './silent-refresh.component.html',
    styleUrls: ['./silent-refresh.component.scss'],
    standalone: false
})
export class SilentRefreshComponent implements OnInit {
  error: boolean;

  constructor(
    private authService: AuthService,
    @Inject(PLATFORM_ID) private _platformId: Object) { }

  async ngOnInit() {
    if (isPlatformServer(this._platformId)) {
      return;
    }

    await this.authService.completeSilentAuthentication();    
  }
}
    